<template>
  <div>
    <v-tabs v-model="tab" right>
      <v-tab
          :href="'#' + i"
          v-for="(tabHeader, i) in tabHeaders"
          :key="i"
          :disabled="parseInt(tab) < i"
      >{{ i + 1 + ". " + tabHeader }}</v-tab
      >
    </v-tabs>

    <v-subheader
        class="background font-weight-bold subtitle-2 px-4 mx-n4 mt-8"
    >{{ subHeaders[tab] }}</v-subheader
    >
    <v-spacer style="height: 20px"></v-spacer>

    <v-tabs-items v-model="tab">
      <v-tab-item
          v-for="i in tabHeaders.length"
          :key="i"
          :value="(i - 1).toString()"
          class="px-3 pt-8"
      >
        <v-form :ref="'form-' + i" v-model="valid[i - 1]">
          <slot :name="'tab-item-' + (i - 1).toString()"></slot>
        </v-form>
      </v-tab-item>
    </v-tabs-items>
    <v-spacer style="height: 50px"></v-spacer>

    <v-row class="px-3">
      <v-btn
          class="mr-3"
          color="primary"
          @click="cancel"
          data-cy="btn-cacnel"
      >{{ i18n.t("_Cancel") }}</v-btn
      >
      <v-btn v-if="parseInt(tab) > 0" @click="back" data-cy="btn-back">{{
          i18n.t("_Back")
        }}</v-btn>
      <v-spacer></v-spacer>
      <v-btn
          v-if="parseInt(tab) === tabHeaders.length - 1"
          color="primary"
          :disabled="!valid[parseInt(tab)]"
          @click="$emit('confirm')"
          data-cy="btn-confirm"
      >{{
          confirmButtonText !== undefined ? confirmButtonText : i18n.t("_Confirm")
        }}</v-btn
      >
      <v-btn
          v-else
          color="primary"
          @click="forward"
          :disabled="!valid[parseInt(tab)]"
          data-cy="btn-continue"
      >{{ i18n.t("_Continue") }}</v-btn
      >
    </v-row>
  </div>
</template>

<script>
import i18n from "../helper/i18n"

export default {
  props: {
    subHeaders: {
      type: Array,
      required: true,
    },
    tabHeaders: {
      type: Array,
      required: true,
    },
    confirmButtonText: {
      type: String,
    },
  },

  data() {
    return {
      valid: [],
      tab: undefined,
      i18n: i18n
    };
  },
  mounted() {
  },
  methods: {
    forward() {
      var i = parseInt(this.tab);
      if (i < this.tabHeaders.length - 1) {
        this.tab = (i + 1).toString();
      }
      this.$emit("forward", parseInt(this.tab));
    },
    back() {
      var i = parseInt(this.tab);
      if (i > 0) {
        this.tab = (i - 1).toString();
      }
      this.$emit("back", this.tab);
    },
    cancel() {
      this.$emit("cancel");
    },
  },
};
</script>

<style></style>
